import { z } from "zod";

export const EmailSchema = z
  .string()
  .trim()
  .email("Ange en giltig e-postadress")
  .max(254);

export const PasswordSchema = z
  .string()
  .min(8, "Lösenordet behöver minst 8 tecken")
  .max(72, "Lösenordet är för långt");

export const SignInSchema = z.object({
  email: EmailSchema,
  password: PasswordSchema,
});

export type SignInInput = z.infer<typeof SignInSchema>;

export const SignUpSchema = z
  .object({
    email: EmailSchema,
    password: PasswordSchema,
    displayName: z.string().trim().min(1).max(80).optional(),
  })
  .strict();

export type SignUpInput = z.infer<typeof SignUpSchema>;

export const ResetPasswordSchema = z.object({
  email: EmailSchema,
});

export type ResetPasswordInput = z.infer<typeof ResetPasswordSchema>;

export const AuthUserFacingErrorSchema = z.enum([
  "AUTH_REQUIRED",
  "INVALID_CREDENTIALS",
  "EMAIL_IN_USE",
  "WEAK_PASSWORD",
  "NETWORK_ERROR",
  "NOT_CONFIGURED",
  "VALIDATION_ERROR",
  "UNKNOWN_ERROR",
]);

export type AuthUserFacingError = z.infer<typeof AuthUserFacingErrorSchema>;
